document.addEventListener('DOMContentLoaded', function () {
  // 1. Add your specific Selling Plan IDs here (as strings)
  const PLAN_2_MONTHS = '712495792502';
  const PLAN_3_MONTHS = '712495825270';

  // 2. Select the quantity elements based on your provided HTML
  const quantityInput = document.querySelector('.quantity__input[name="quantity"]');
  const minusBtn = document.querySelector('quantity-input button[name="minus"]');
  const plusBtn = document.querySelector('quantity-input button[name="plus"]');

  // Select all the radio buttons in your custom subscription UI
  const purchaseOptions = document.querySelectorAll(
    '.selling_plan_app_container input[type="radio"]'
  );

  // 3. Main synchronization logic
  function updateQuantityBehavior(selectedRadio) {
    if (!quantityInput) return;

    // Grab the data attributes from your provided HTML
    const planId = selectedRadio.getAttribute('data-selling-plan-id');

    if (planId === PLAN_2_MONTHS) {
      setAndLockQuantity(2);
    } else if (planId === PLAN_3_MONTHS) {
      setAndLockQuantity(3);
    } else {
      // Handles data-radio-type="one_time_purchase" or standard subscriptions
      unlockQuantity();
    }
  }

  // Helper: Lock the quantity to a specific number
  function setAndLockQuantity(qty) {
    quantityInput.value = qty;
    quantityInput.setAttribute('readonly', 'readonly');

    if (minusBtn) {
      minusBtn.disabled = true;
    }
    if (plusBtn) {
      plusBtn.disabled = true;
    }
  }

  // Helper: Unlock the quantity and reset to 1
  function unlockQuantity() {
    quantityInput.removeAttribute('readonly');
    if (minusBtn) {
      minusBtn.disabled = false;
    }
    if (plusBtn) {
      plusBtn.disabled = false;
    }

    // We reset to 1 so the user doesn't accidentally buy 3 products
    // at a one-time price when switching back from the 3-stack option
    if (parseInt(quantityInput.value) > 1) {
      quantityInput.value = 1;
    }
  }

  // 4. Attach the listeners to your radio buttons
  if (purchaseOptions.length > 0) {
    purchaseOptions.forEach((radio) => {
      radio.addEventListener('change', function () {
        if (this.checked) {
          updateQuantityBehavior(this);
        }
      });
    });

    // 5. Run once on page load to handle the pre-checked radio button
    const initialChecked = document.querySelector(
      '.selling_plan_app_container input[type="radio"]:checked'
    );
    if (initialChecked) {
      updateQuantityBehavior(initialChecked);
    }
  }

  // --- Reset UI after Add to Cart ---

  // 1. Find the product form by looking up from the quantity input
  if (quantityInput) {
    // Grab the exact form ID using the input's "form" attribute
    const formId = quantityInput.getAttribute('form');

    // Find the form by its ID, or fallback to the standard cart add action
    const productForm = formId
      ? document.getElementById(formId)
      : document.querySelector('form[action$="/cart/add"]');

    if (productForm) {
      productForm.addEventListener('submit', function () {
        setTimeout(function () {
          const oneTimeRadio = document.querySelector(
            '.selling_plan_app_container input[data-radio-type="one_time_purchase"]'
          );

          if (oneTimeRadio && !oneTimeRadio.checked) {
            oneTimeRadio.checked = true;
            oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 1000); // Wait 1000ms for AJAX cart to process before resetting
      });
    }
  }
});
